// How one attachment variant is shown in the current media mode (DESIGN §5.1).
// → { kind: "sw", src } | { kind: "url", src } (demo) | { kind: "pending" } | { kind: "placeholder" } | { kind: "unavailable" }
import { mediaSrc } from "../format.js";

export const SW_WHOLE_CAP_BYTES = 32 * 2 ** 20;
const KCM1_TYPES = new Set(["video", "audio", "document"]);
const UNAVAILABLE = Object.freeze({ kind: "unavailable" });

function servable(item, variant, swWholeCapBytes) {
  if (item.format === "kcm1" && KCM1_TYPES.has(item.type)) {
    return variant === "display" || (item.type === "video" && item.hasThumbnail === true);
  }
  if (item.format === "gcm" && item.type === "image") {
    if (variant === "thumbnail") return item.hasThumbnail === true;
    return item.bytes === undefined || item.bytes === null || item.bytes <= swWholeCapBytes;
  }
  return false;
}

export function mediaPlan(item, variant, { mode, demo = false, binding, projectionId, swWholeCapBytes = SW_WHOLE_CAP_BYTES } = {}) {
  if (demo) {
    const src = mediaSrc(item, variant === "display");
    return src ? { kind: "url", src } : UNAVAILABLE;
  }
  if (mode === "pending") return { kind: "pending" };
  if (mode === "no-sw") return { kind: "placeholder" };
  if (!binding) return { kind: "pending" };
  if (variant !== "display" && variant !== "thumbnail") return UNAVAILABLE;
  if (!item?.mediaId || !projectionId) return UNAVAILABLE;
  if (!servable(item, variant, swWholeCapBytes)) return UNAVAILABLE;
  const path = [binding, projectionId, item.mediaId].map(encodeURIComponent).join("/");
  return { kind: "sw", src: `/media-stream/${path}/${variant}` };
}
